import { Component, OnInit } from '@angular/core';
import { EChartsOption } from 'echarts';
import { forkJoin } from 'rxjs';
import { DashboardService } from '../dashboard.service';

@Component({
  selector: 'app-weekly-sales-graph',
  templateUrl: './weekly-sales-graph.component.html',
  styleUrls: ['./weekly-sales-graph.component.scss'],
})
export class WeeklySalesGraphComponent implements OnInit {
  public isLoaded: boolean = false;
  public echartHorizontalLineChart: EChartsOption = {};

  constructor(private dashBoardService: DashboardService) {}

  ngOnInit(): void {
    this.loadLastSales();
  }

  loadLastSales(): void {
    this.isLoaded = true;

    forkJoin({
      Last7DaysSales: this.getLast7DaysSales(),
      last7DaysReceivedSales: this.getLast7DaysReceivedSales(),
    }).subscribe({
      next: (results) => {
        const Last7DaysSales = results.Last7DaysSales;
        const last7DaysReceivedSales = results.last7DaysReceivedSales;

        this.mountGraph(
          Last7DaysSales.labels,
          Last7DaysSales.values,
          last7DaysReceivedSales.values
        );
      },
      error: (error) => {
        console.error('Erro ao carregar os saldos', error);
      },
      complete: () => {
        this.isLoaded = false;
      },
    });
  }

  getLast7DaysSales() {
    return this.dashBoardService.getLast7DaysSales().then((value) => {
      return value;
    });
  }

  getLast7DaysReceivedSales() {
    return this.dashBoardService.getLast7DaysReceivedSales().then((value) => {
      return value;
    });
  }

  mountGraph(
    labels: string[],
    last7DaysSales: number[],
    last7DaysReceivedSales: number[]
  ) {
    this.echartHorizontalLineChart = {
      valueAxis: {
        axisLine: {
          lineStyle: {
            color: 'rgba(171, 167, 167,0.2)',
          },
        },
        splitArea: {
          show: true,
          areaStyle: {
            color: ['rgba(171, 167, 167,0.2)'],
          },
        },
        splitLine: {
          lineStyle: {
            color: ['rgba(171, 167, 167,0.2)'],
          },
        },
      },
      grid: {
        top: '6',
        right: '0',
        bottom: '17',
        left: '70',
      },
      tooltip: {
        trigger: 'axis',
        position: ['35%', '32%'],
      },
      xAxis: {
        data: labels,
        axisLine: {
          lineStyle: {
            color: 'rgba(171, 167, 167,0.2)',
          },
        },
        splitLine: {
          lineStyle: {
            color: 'rgba(171, 167, 167,0.2)',
          },
        },
        axisLabel: {
          fontSize: 10,
          color: '#5f6d7a',
        },
      },
      yAxis: {
        splitLine: {
          lineStyle: {
            color: 'rgba(171, 167, 167,0.2)',
          },
        },
        axisLine: {
          lineStyle: {
            color: 'rgba(171, 167, 167,0.2)',
          },
        },
        axisLabel: {
          fontSize: 10,
          color: '#5f6d7a',
          formatter: (param: Object): string => {
            return Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
            }).format(parseInt(String(param)));
          },
        },
      },
      series: [
        {
          name: 'Depósitos gerados',
          type: 'bar',
          barMaxWidth: 20,
          data: last7DaysSales,
        },
        {
          name: 'Depósitos recebidos',
          type: 'bar',
          barMaxWidth: 20,
          data: last7DaysReceivedSales,
        },
      ],
      color: ['#0CC7E0', '#094FDB'],
    };
  }
}
